export interface ChatAgentMentionOption {
  id: string | null;
  name: string;
}

export interface ResolvedChatAgentMention {
  botId: string | null;
  input: string;
}

export function resolveLeadingChatAgentMention(
  input: string,
  bots: readonly ChatAgentMentionOption[]
): ResolvedChatAgentMention | null {
  const trimmed = input.trimStart();
  if (!trimmed.startsWith('@')) return null;

  const candidates = [...bots]
    .filter(bot => bot.name.trim().length > 0)
    .sort((a, b) => b.name.length - a.name.length);
  const lower = trimmed.toLowerCase();

  for (const bot of candidates) {
    const token = `@${bot.name.trim().toLowerCase()}`;
    if (!lower.startsWith(token)) continue;

    const next = trimmed[token.length];
    if (next && !/\s/.test(next)) continue;

    return {
      botId: bot.id,
      input: trimmed.slice(token.length).trimStart(),
    };
  }

  return null;
}
